import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './fonts'
import './index.css'
import './i18n'
import { App } from './app/App'
import { clearDevServiceWorkers, setupPwa } from './pwaRegister'

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Missing #root element in index.html')

async function bootstrap() {
  await clearDevServiceWorkers()
  void setupPwa()

  createRoot(rootEl!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void bootstrap()
